import { $$ } from '@starberry/components';

const ContentSection = {
  $: 'Stack',
  props: {
    spacing: [4, null, 6],
  },
  children: ({ title, textProps, rightLink = {}, content = [] }) => {
    return [
      {
        $: 'Flex',
        props: {
          justifyContent: 'space-between',
        },
        children: [
          {
            $: 'SectionHeading',
            title,
            textProps,
          },
          rightLink && {
            $: 'Tooltip',
            props: {
              label: 'adasd'
            },
            children: {
              $: 'WrappedLink',
              props: {
                to: rightLink.href,
                fontSize: ['12px', null, '18px'],
                lineHeight: ['20px', null, '26px'],
                fontWeight: ['bold', null, 'normal'],
                color: $$('constants.colors.grey2', null, 'constants.colors.primary'),
              },
              children: rightLink.text,
            },
          },
        ],
      },
      ...content,
    ];
  },
};

export default ContentSection;
